import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faClock } from "@fortawesome/free-solid-svg-icons";
import "./styles/works.css";

const Works = ({ address }) => {
    return (
        <div className="works-body">
            <div className="location-card">
                <div className="location-icon">
                    <FontAwesomeIcon icon={faMapMarkerAlt} alt="Location marker icon"/>
                </div>
                <div className="location-details">
                    <h3>Visit Us</h3>
                    <p>{address}</p>
                    <a 
                        href="https://www.openstreetmap.org/search?query=7121+Leesburg+Pike%2C+Falls+Church%2C+VA+22043" 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="directions-link"
                    >
                        Get Directions
                    </a>
                </div>
            </div>
            
            {/* <div className="location-card">
                <div className="location-icon">
                    <FontAwesomeIcon icon={faPhone} alt="Phone icon"/>
                </div>
                <div className="location-details">
                    <h3>Call Us</h3>
                    <p>+1 (703) 555-1234</p>
                    <a 
                        href="tel:+17035551234" 
                        className="directions-link"
                    >
                        Call Now
                    </a>
                </div>
            </div> */}
            
            <div className="location-card">
                <div className="location-icon">
                    <FontAwesomeIcon icon={faClock} alt="Clock icon"/>
                </div>
                <div className="location-details">
                    <h3>Opening Hours</h3>
                    <p>Tue-Fri: 9AM - 7PM</p>
                    <p>Sat: 9AM - 6PM</p>
                    <p>Sun: 10AM - 4PM</p>
                </div>
            </div>
        </div>
    );
};

export default Works;
